<template>
    <th>
        <input type="checkbox" v-model="checked" :indeterminate.prop="indeterminate" :class="{ indeterminate }" />
    </th>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: Array,
        required: true,
    },
    values: {
        type: Array,
        required: false,
    },
})

const emit = defineEmits(['update:modelValue'])

const checked = computed({
    get: () => props.values.every(v => (props.modelValue ?? []).includes(v)),
    set(value) {
        const set = new Set(props.modelValue ?? [])

        if (value) {
            props.values.forEach(v => set.add(v))
        } else {
            props.values.forEach(v => set.delete(v))
        }

        emit('update:modelValue', [...set])
    },
})

const indeterminate = computed(() => !checked.value && props.values.some(v => (props.modelValue ?? []).includes(v)))
</script>
<style scoped>
input {
    position: relative;
    top: -8px;
}
</style>
